import { SecuredClient } from 'Core/Api/SecuredClient';
import {
    GetAllAdminsByFilterCommandRequest,
    GetAllAdminsByFilterCommandResponse,
    SlimAdministrator,
    AddAdminUserCommandRequest,
    AddAdminUserCommandResponse,
    GetAllRolesByFilterCommandResponse,
} from '../../../Core/Api/Api';

export class AdministratorHandler {
    constructor(props?: any) { }
    
    async GetData(request: GetAllAdminsByFilterCommandRequest): Promise<GetAllAdminsByFilterCommandResponse> {
        const client = new SecuredClient();
        client.showLoading = false; // Set to false since loading is managed by component
        client.handleGeneralError = true;
        
        try {
            const response = await client.getAdminsByFilter(request);
            return response;
        } catch (error) {
            console.error('Error fetching administrators:', error);
            throw error;
        }
    }

    /**
     * Add a new admin user
     * @param request AddAdminUserCommandRequest
     * @returns AddAdminUserCommandResponse
     */
    async addAdminUser(request: AddAdminUserCommandRequest): Promise<AddAdminUserCommandResponse> {
        const client = new SecuredClient();
        client.showLoading = true; // Show loading for this operation
        client.handleGeneralError = true;
        
        try {
            return await client.addAdminUser(request);
        } catch (error) {
            console.error('Error adding admin user:', error);
            throw error;
        } finally {
            client.showLoading = false;
        }
    }

    async getRoles(): Promise<GetAllRolesByFilterCommandResponse> {
        const client = new SecuredClient();
        client.showLoading = false; // Don't show loading for roles
        client.handleGeneralError = true;
        
        try {
            return await client.getAllRoles();
        } catch (error) {
            console.error('Error fetching roles:', error);
            throw error;
        } finally {
            client.showLoading = false;
        }
    }
}